import React from 'react';
import { PolicyPlate, DataPlate, StrategyPlate } from '../HilmaPlates';

/*
  Card data for the three service cards on Home. Each card passes a
  Hilma-style symbolic plate (rendered as inline SVG) into SplitComponent's
  `plate` slot, instead of an image.
*/

export const cardPolicy = {
  plate: <PolicyPlate />,
  image: 'images/bkg-farm.png',
  title: 'Policy Innovation',
  subtitle: 'Policy development & evaluation',
  par1:
    'We partner with organisations and governments to craft innovative policy solutions, drawing on academic rigour and frontier research.',
  par2:
    'Our approach integrates robust evidence with deep local context, accounting for social, political and financial risk so policies are implementable, cost-effective, and durable.',
  capabilities: ['Design', 'Implementation', 'Evaluation', 'Risk'],
};

export const cardData = {
  plate: <DataPlate />,
  image: 'images/bkg-data.png',
  title: 'Decision Analytics',
  subtitle: 'Data analytics for decision-making',
  par1:
    'We employ advanced quantitative techniques on large and complex datasets, translating findings into policy insights that decision-makers can act on.',
  par2:
    'From population surveys to financial microdata, we build bespoke analytics and visualisation tools that support rigorous design, monitoring and evaluation.',
  capabilities: ['Econometrics', 'Visualisation', 'Monitoring', 'Decision'],
};

export const cardPolitics = {
  plate: <StrategyPlate />,
  image: 'images/bkg-meet3.png',
  title: 'Forging Visions',
  subtitle: 'Strategic foresight & direction',
  par1:
    'We guide leaders and decision-makers through dynamic operating environments, helping them set a direction that is robust to political shifts, technological change, and evolving public sentiment.',
  par2:
    'Recognising that execution is today’s leading challenge,\nwe support thoughtful delivery across the policy lifecycle.',
  capabilities: ['Strategy', 'Public Affairs', 'Execution', 'Delivery'],
};
